import { render, staticRenderFns } from "./LicensesFilter.vue?vue&type=template&id=db9a4e9c"
import script from "./LicensesFilter.vue?vue&type=script&lang=js"
export * from "./LicensesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports